import { button } from '../../../../../component/component'

export default function(o,p){

  var name = p.model.getName()

  if(!p.item){
    name += '/new'
  }

  name = name.toUpperCase()

  var div =
    button(name,null,true)
    .css({
      position: 'absolute',
      left: 0,
    })

  return div

}


// WEBPACK FOOTER //
// ./src/client/view/admin/edit/form/label/label.js